import { parseMetadata } from '../../../apps/professional-app/fa/MeetingSummary/utils'

import { BusinessEvent, ResolvedBusinessEventSource } from '../../../models/BusinessEvent'
import { formatDate } from '../../../apps/professional-app/fa/common/aifeatures/utils'

export const getBusinessEventSourceKey = (businessEvent: BusinessEvent) => {
  const { source } = businessEvent
  const sourceParts = source.type === 'email' ? [source.type, source.emailConnector, source.emailId] : [source.type, source.roomId, source.sessionId]
  return sourceParts.join('|')
}

export const getResolvedBusinessEventSourceLabel = (resolvedSource: ResolvedBusinessEventSource) => {
  const { type, source } = resolvedSource
  if (type === 'email') {
    return `Incoming mail on ${formatDate(source.createdAt)}`
  }
  const { external } = parseMetadata(source.metadata)
  return external.title ?? 'Untitled Meeting'
}

export const getResolvedBusinessEventSourceLink = (resolvedSource: ResolvedBusinessEventSource) => {
  const { type, source } = resolvedSource
  if (type === 'email') {
    return `/dashboard/email/inbox/threads/${source.threadId}`
  }
  return `/dashboard/workspace/past-meetings/room/${source.roomId}/session/${source.id}`
}
